export default {
    formatDate (value){
        if(!value){
            return value;
        }
        var date = new Date(value);
        // 月
        if ((date.getMonth() + 1) >= 10) {
            var month = date.getMonth() + 1;
        } else {
            var month = '0' + (date.getMonth() + 1);
        }
        // 日
        if (date.getDate() >= 10) {
            var day = date.getDate();
        } else {
            var day = '0' + date.getDate();
        }
        // 时
        if (date.getHours() >= 10) {
            var hours = date.getHours();
        } else {
            var hours = '0' + date.getHours();
        }
        // 分
        if (date.getMinutes() >= 10) {
            var minutes = date.getMinutes();
        } else {
            var minutes = '0' + date.getMinutes();
        }
        return date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + minutes
         
            
    }
}


// WEBPACK FOOTER //
// ./src/js/filter.js